export default {"src":"https://cdn.jetlend.ru/_next/static/media/blockquote.7cb8d268.svg","height":28,"width":44,"blurWidth":0,"blurHeight":0};